<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <nav>
    <button
      class="mobile-group-toggle"
      :class="{ '-active': isActive }"
      data-testid="navigation-language-menu-mobile"
      @click="toggleMobileGroup(index)"
    >
      <span>{{ selectedLanguage.details.label }}</span>
      <span class="toggle-icon" :class="{ '-active': isActive }">
        <Icon icon="fa6-solid:angle-down" data-icon="fa6-solid:angle-down" />
      </span>
    </button>
    <transition name="slide-down">
      <ul v-if="activeMobileGroup === index" class="mobile-sublinks">
        <li
          v-for="(language, index) in languages"
          :key="language.details.locale"
          :aria-selected="language === selectedLanguage"
          @click="selectLanguage(language)"
          @keydown.down.prevent="focusNextItem(index)"
          @keydown.up.prevent="focusPrevItem(index)"
          @keydown.esc.prevent="close"
        >
          <a
            :href="language.url"
            data-testid="navigation-language-mobile"
            @click="$emit('emittedClick', { type: 'language', el: language })"
          >
            {{ language.details.label }}
          </a>
        </li>
      </ul>
    </transition>
  </nav>
</template>

<script>
import navigationDefaultGlobalProps from "../navigationDefaultGlobalProps.js";
import { Icon } from "@iconify/vue";
import { navigationSlidedownMixins } from "./slidedownMixins.js";

export default {
  name: "NavigationUILanguageSlidedown",
  components: {
    Icon,
  },
  mixins: [navigationSlidedownMixins],
  props: {
    languages: {
      type: Array,
      required: true,
      default: () => navigationDefaultGlobalProps.config.general.languages,
    },
    pageLocale: {
      type: String,
      default: "",
    },
  },
  emits: ["emittedClick", "toggle-group"],
  data() {
    return {
      isOpen: false,
      selectedLanguage: {},
    };
  },
  created() {
    // preselect the selectedLanguage based on the language locale of the page
    // only if pageLocale is set && language equal to it is present
    if (
      this.pageLocale &&
      this.languages.some(
        (language) => language.details.locale === this.pageLocale,
      )
    ) {
      this.selectedLanguage = this.languages.find(
        (language) => language.details.locale === this.pageLocale,
      );
    } else {
      this.selectedLanguage = this.languages[0];
    }
  },
  methods: {
    selectLanguage(language) {
      this.selectedLanguage = language;
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./slidedown.scss";
</style>
